import React from 'react';
import { useSelector } from 'react-redux';
import { isMobile } from 'react-device-detect';

import { retrieveLineConfig } from 'utils/manipulatePartnerSponsor';

import LoginLine from 'client/components/dialogLogin/LoginLine';
import LoginLineLiff, { types } from 'client/components/dialogLogin/LoginLineLiff';
import useLineEnv from 'hooks/useLineEnv';

function LoginLineContainer() {
    const {
        partner,
        sponsor,
        appState: { hasTryLiff }
    } = useSelector(s => s);
    const { isInLiffBrowser, isInLineAppBrowser } = useLineEnv();

    const { lineLoginAppLiffId } = retrieveLineConfig({ partner, sponsor });
    const canUseLiff = Boolean(lineLoginAppLiffId);

    if (isMobile) {
        // android v8,v11 facebook can not open liff suck bug liff v2.4.1
        // 所以需要假裝在 liff browser 以免無限循環
        const notLineBrowser = !isInLineAppBrowser && !isInLiffBrowser;
        const mobileShouldUseLiffLogin = canUseLiff && notLineBrowser && !hasTryLiff;
        return mobileShouldUseLiffLogin ? <LoginLineLiff type={types.BUTTON} /> : <LoginLine />;
    } else {
        return canUseLiff ? <LoginLineLiff type={types.QRCODE} isPC /> : <LoginLine />;
    }
}

export default LoginLineContainer;
